import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { EntityTransformed } from "~pages/Entities/types/entityTransformed.ts";
import type { SearchFilterParams } from "~pages/Persons/PersonListPage/types/searchFilterParams.ts";
import type { EntityResponse } from "~types/entity.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

const useFetchEntities = (params: SearchFilterParams, enabled: boolean) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  const url = `${sport}/o/${organizationId}/entities?${new URLSearchParams(removeEmptyFields(params) as Record<string, string>).toString()}`;

  return useQuery({
    queryKey: ["entities", sport, organizationId, params],
    enabled: enabled,
    queryFn: async () =>
      request<EntityResponse>(url).then((response) => {
        const entityGroups = response?.includes?.resources?.entityGroups || {};
        const data = (response?.data || []).map((entity) => {
          return {
            ...entity,
            entityGroup: entity?.entityGroup?.id ? entityGroups[entity?.entityGroup?.id] : null,
          };
        });
        return transformListResponse({ ...response, data: data as Array<EntityTransformed> });
      }),
  });
};

export default useFetchEntities;
